export const contact1 = require('./contact1.mp4')